import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { graphql, Link } from "gatsby"
import axios from "axios"
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from "react-share"

import Layout from "../components/layout"
import blogDetailLink from "../utils/blogDetailLink"
//import Banner from "../components/general/banner/banner";
import Categories from "../components/general/categories/categories"
import MostViewed from "../components/general/categories/mostviewed"
import { Col, Row } from "react-bootstrap"
import SEO from "../components/seo"
//import convertToSlug from '../utils/convertToSlug';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFacebookF, faLinkedinIn, faTwitter } from "@fortawesome/free-brands-svg-icons"
import { SaRecommendPostEditor } from "../components/post/recommend_post_editor"

//import IMG2 from '../images/48x48.png';
//import Postimg from '../images/img2.jpg';
//import IMG1 from '../images/img3.png';

const BlogDetailpage = ({ data, pageContext }) => {
  const post = data.wpPost;
  const [scroll, setScroll] = useState(false)
  const [mostviewedids, setMostviewedIds] = useState([])
  const related_posts = post.related_posts




  // get editor
  const [saEditor, setSaEditor] = useState(false)
  useEffect(() => {
    axios.get('https://dev-furlough.pantheonsite.io/wp-json/top-10/v1/popular-posts?limit=5')
      .then(function (response) {
        // handle success
        //console.log(response);
        let mostviewed_ids = response.data.map(m => { return m.id })
        setMostviewedIds(mostviewed_ids)
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      })
  },[saEditor])


  //const ComponentName = ({ data }) => <pre>{JSON.stringify(related_posts, null, 4)}</pre>


  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 160)
    })

    axios.get('https://dev-furlough.pantheonsite.io/wp-json/top-10/v1/popular-posts?limit=5')
    .then(function (response) {
      // handle success
      //console.log(response);
      let mostviewed_ids = response.data.map(m => { return m.id })
      setMostviewedIds(mostviewed_ids)
    })
    .catch(function (error) {
      // handle error
      console.log(error);
    })
    
    var mostviewed_data = new FormData();
    mostviewed_data.append('top_ten_id', pageContext.databaseId);
    mostviewed_data.append('action', 'tptn_tracker');
    mostviewed_data.append('activate_counter', '11');
    mostviewed_data.append('top_ten_debug', '0');
    mostviewed_data.append('top_ten_blog_id', '1');

    var mostviewed_tracker = {
      method: 'post',
      url: 'https://dev-furlough.pantheonsite.io/wp-json/top-10/v1/tracker',
      data : mostviewed_data
    };

    axios(mostviewed_tracker)
    .then(function (response) {
      //console.log(JSON.stringify(response.data));
    })
    .catch(function (error) {
      console.log(error);
    });
    
   
  }, [])




  return (
    <Layout>

      <SEO title={post.metaMain.title} description={post.metaMain.description} ogimage={post.metaMain.ogimage && post.metaMain.ogimage.sourceUrl} />
      <div className="mb-5 detail-post">

        {/*<div className={'my-6'}>
          <pre>{JSON.stringify(post, null, 4)}</pre>
        </div>*/}


       {/* <div className={'my-6'}>
          <pre>{JSON.stringify(related_posts, null, 4)}</pre>
        </div>*/}

        <div className={'saContainer'}>
          <Row>
            <Col lg="8" className="blog-detail-container">
              <div className="blog-post" style={{width: "100%"}}>
                {post.terms.nodes.filter(term => term.nodeType==="Category").slice(0,1).map(term => (
                  <h2 style={{width: "100%", textTransform: "capitalize"}} className={term.ancestors ? term.ancestors.nodes[0].slug : term.slug}>{term.name}<span></span></h2>
                ))}
                <h3>{post.title}</h3>
              </div>

              <div className="article-card-text">
                <div className="d-flex flex-wrap">
                  {post.terms.nodes.filter(term => term.nodeType==="Category").slice(0,1).map(term => (
                    <Link to={`/${term.slug}`} className={term.ancestors ? `btn-custom me-2 btn-1 ${term.ancestors.nodes[0].slug}` : `btn-custom me-2 ${term.slug}`}>{term.name}</Link>
                  ))}
                    
                  <ul>
                    {post.author
                    ?
                      <>
                        {post.author.node.slug && <li><Link to={`/contributor/${post.author.node.slug}`}>{post.author.node.firstName} {post.author.node.lastName}</Link></li>}
                      </>
                    :
                      <>
                        {post.postFields.defaultFields.author && <li><Link to="#">{post.postFields.defaultFields.author}</Link></li>}
                      </>
                    }

                    <li>{post.date}</li>
                    {post.terms.nodes.filter(term => term.nodeType==="Tag").slice(0,1).map(term => (
                      <li>{term.name}</li>
                    ))}
                  </ul>
                </div>
              </div>
              
              <div style={{marginTop: "20px"}}>
              {post.postFields.defaultFields.featuredImage && <img src={post.postFields.defaultFields.featuredImage.sourceUrl} alt="post" className="img-fluid" />}
              {post.postFields.defaultFields.postTemplates && post.postFields.defaultFields.postTemplates.map(template => (
              <>
                {template.content && <div dangerouslySetInnerHTML={{__html: template.content}} />}
                {template.image && <img src={template.image.sourceUrl} className="img-fluid" alt="" />}
                {template.link && 
                <div
                  dangerouslySetInnerHTML={{
                    __html: `
                  <blockquote className="instagram-media" data-instgrm-captioned data-instgrm-version="12" data-instgrm-permalink="${template.link}"></blockquote>`
                  }}
                />
                }
              </>
              ))}
              </div>
            </Col>
            <Col lg="1"></Col>
            <Col lg="3" className={scroll ? "sidebar d-none d-lg-block" : "pt-3 sidebar d-none d-lg-block"}>
              <div className={scroll ? "scroll-category" : ""}>
                <Categories />
                {mostviewedids.length > 0 && <MostViewed ids={mostviewedids} />}
              </div>
            </Col>
          </Row>
        </div>
        <div className="recommend-posts">
          <div className={'saContainer'}>
            {related_posts.nodes.map(rpost => (
              <>
                {/*-- Desktop Sections Start --*/}
                  <div className="hidden-md-down">
                    <div className="border-bottom article-p pb-5 pt-5">  
                      <Row>
                        <Col className="article-info" lg="2">
                          <div className="article-info__main-analyst mb-3">
                            <div className="">
                              <Link to={`/contributor/${rpost.author.node.slug}`} style={{width:"95px", display:"block"}}>
                                <img style={{width:"86px"}} className="img-fluid mb-0" src={rpost.author.node.avatar.url} alt=""  />
                              </Link>
                            </div>
                            <div className="mt-1">
                              <Link to={`/contributor/${rpost.author.node.slug}`} className="article-info__analyst-link">{rpost.author.node.name}</Link>
                            </div>
                            <div className="article-info__analyst-job mt-1">
                              {rpost.author.node.moreInformation.userLocation}
                              {rpost.author.node.moreInformation.userLocation && <br />}
                              <Link to={`/contributor/${rpost.author.node.slug}`}>Author</Link>
                            </div>
                            {/*<div className="mt-3 pb-3">
                              <button className="btn-follow">
                                <span>Follow</span>
                              </button>
                            </div>*/}
                          </div>


                          {
                            rpost.customPostEditor
                            && rpost.customPostEditor.postEditorRelationship
                            && rpost.customPostEditor.postEditorRelationship[0]
                            && rpost.customPostEditor.postEditorRelationship[0].customUsers.customUserId
                            && <SaRecommendPostEditor UserID={rpost.customPostEditor.postEditorRelationship[0].customUsers.customUserId} />
                          }

                         {/* <div className="article-info__main-analyst mb-3">
                            <div className="">
                              <Link to={`/contributor/${rpost.author.node.slug}`} style={{width:"95px", display:"block"}}>
                                <img style={{width:"86px"}} className="img-fluid mb-0" src={rpost.author.node.avatar.url} alt=""  />
                              </Link>
                            </div>
                            <div className="mt-1">
                              <Link to={`/contributor/${rpost.author.node.slug}`} className="article-info__analyst-link">{rpost.author.node.name}</Link>
                            </div>
                            <div className="article-info__analyst-job mt-1">
                              {rpost.author.node.moreInformation.userLocation}
                              {rpost.author.node.moreInformation.userLocation && <br />}
                              <Link to={`/contributor/${rpost.author.node.slug}`}>Editor</Link>
                            </div>
                          </div>*/}


                          <div className="py-2 border-bottom border-top mb-5">{rpost.date}</div>
                          {/*<div className="d-flex article-info__partner mt-3">
                            <img className="img-fluid" src={IMG2} />
                            <div className="d-flex flex-column article-info__partner-info">
                              <span>Published by</span>
                              <a href="#" className="article-info__provider">ING Think</a>
                            </div>
                          </div>*/}
                        </Col>
                        <Col className="article-page__main" lg="7">
                          <div className="article-topic d-flex align-items-center">
                            {rpost.categories.nodes.slice(0,1).map(cat => (
                              <Link to={blogDetailLink(rpost)} className={`/${cat.slug}`}>{cat.name.toUpperCase()}</Link>
                            ))}
                          </div>
                          <h2 className="article-title">
                            <Link to={blogDetailLink(rpost)}>
                              {rpost.title}
                            </Link>
                          </h2>
                          <div className="post-text">
                            <Link to={blogDetailLink(rpost)}>
                              <img className="img-fluid" src={rpost.postFields?.defaultFields?.featuredImage?.sourceUrl} alt="#" />
                            </Link>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: rpost.excerpt
                              }}
                            />
                            <Link to={blogDetailLink(rpost)} className={'saBlogSingleReadMore'} style={{fontWeight:"bold"}}>Read More</Link>
                          </div>
                        </Col>
                        <Col lg="2" className="offset-lg-1">
                          <div className="article-share">
                            <div className="article-share-title">Share this article</div>
                            <ul>
                              <li>
                                <FacebookShareButton url={`https://furlough.com/${blogDetailLink(rpost)}`}><FontAwesomeIcon icon={faFacebookF}/></FacebookShareButton>
                              </li>
                              <li>
                                <LinkedinShareButton url={`https://furlough.com/${blogDetailLink(rpost)}`}><FontAwesomeIcon icon={faLinkedinIn}/></LinkedinShareButton>
                              </li>
                              <li>
                                <TwitterShareButton url={`https://furlough.com/${blogDetailLink(rpost)}`}><FontAwesomeIcon icon={faTwitter}/></TwitterShareButton>
                              </li>
                            </ul>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                {/*-- Desktop Sections End --*/}
                {/*-- Mobile Sections Start --*/}
                  <div className="hidden-md-up">
                    <div className="border-bottom article-p pb-4 pt-5">  
                        <Row>
                          <Col className="article-page__main" lg="7">
                            <div className="article-topic d-flex align-items-center">
                              {rpost.categories.nodes.slice(0,1).map(cat => (
                                <Link to={blogDetailLink(rpost)} className={`/${cat.slug}`}>{cat.name.toUpperCase()}</Link>
                              ))}
                            </div>
                            <h2 className="article-title">
                              <Link to={blogDetailLink(rpost)}>
                                {rpost.title}
                              </Link>
                            </h2>
                            <div className="post-text">
                              <Link to={blogDetailLink(rpost)} style={{fontWeight:"bold"}}>
                                <img className="img-fluid" src={rpost.postFields?.defaultFields?.featuredImage?.sourceUrl} alt="#" />
                              </Link>
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: rpost.excerpt
                                }}
                              />
                              <Link to={blogDetailLink(rpost)} className={'saBlogSingleReadMore'}  style={{fontWeight:"bold"}}>Read More</Link>
                            </div>
                          </Col>
                          <Col className="article-info " lg="2">
                            <div className="article-info__main-analyst mt-4">
                                <div className="">
                                  <Link to={`/contributor/${rpost.author.node.slug}`} style={{width:"95px", display:"block"}}>
                                    <img style={{width:"86px"}} className="img-fluid mb-0" src={rpost.author.node.avatar.url} alt=""  />
                                  </Link>
                                </div>
                                <div className="mt-1">
                                  <Link to={`/contributor/${rpost.author.node.slug}`} className="article-info__analyst-link">{rpost.author.node.name}</Link>
                                </div>
                                <div className="article-info__analyst-job mt-1">
                                  {rpost.author.node.moreInformation.userLocation}
                                  {rpost.author.node.moreInformation.userLocation && <br />}
                                  <Link to={`/contributor/${rpost.author.node.slug}`}>{rpost.author.node.moreInformation.role}</Link>
                                </div>
                              {/*<div className="mt-3 pb-3">
                                <button className="btn-follow">
                                  <span>Follow</span>
                                </button>
                              </div>*/}
                            </div>
                            <div className="py-2 border-bottom border-top mt-3 mb-3">{rpost.date}</div>
                            {/*<div className="d-flex article-info__partner mt-3">
                              <img className="img-fluid" src={IMG2} />
                              <div className="d-flex flex-column article-info__partner-info">
                                <span>Published by</span>
                                <a href="#" className="article-info__provider">ING Think</a>
                              </div>
                            </div>*/}
                          </Col>
                          <Col lg="2" className="offset-lg-1">
                            <div className="article-share">
                              <div className="article-share-title">Share this article</div>
                              <ul>
                                <li>
                                  <FacebookShareButton url={`https://furlough.com/${blogDetailLink(rpost)}`}><FontAwesomeIcon icon={faFacebookF}/></FacebookShareButton>
                                </li>
                                <li>
                                  <LinkedinShareButton url={`https://furlough.com/${blogDetailLink(rpost)}`}><FontAwesomeIcon icon={faLinkedinIn}/></LinkedinShareButton>
                                </li>
                                <li>
                                  <TwitterShareButton url={`https://furlough.com/${blogDetailLink(rpost)}`}><FontAwesomeIcon icon={faTwitter}/></TwitterShareButton>
                                </li>
                              </ul>
                            </div>
                          </Col>
                        </Row>
                      </div>
                  </div>
                {/*-- Mobile Sections End --*/}
               </>
              ))}
              <Row>
            
              {/**/}

              {/*
              <Col className="article-page__main" lg="6" className="offset-lg-3">
                <div className="article-topic d-flex align-items-center">
                  <Link className="topic-light">Macro Analysis /</Link>
                  <Link to="" className="normal topic__region ms-1">Global</Link>
                </div>
                <h2 className="article-title">
                  Shortages set to affect goods prices globally, but maybe not for long
                </h2>
                <div className="post-text">
                  <img className="img-fluid" src={Postimg} alt="#" />
                  <p>Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries for previewing layouts and visual mockups....</p>
                  <Link to="#" style={{fontWeight:"bold"}}>Read More</Link>
                </div>
              </Col>
              */}

              {/*
              <Col lg="3" className="offset-lg-1">
                <div className="article-share">
                  <div className="article-share-title">Share this article</div>
                  <ul>
                    <li>
                      <a href=""><FontAwesomeIcon icon={faLinkedinIn}/></a>
                    </li>
                    <li>
                      <a href=""><FontAwesomeIcon icon={faFacebookF}/></a>
                    </li>
                    <li>
                      <a href=""><FontAwesomeIcon icon={faTwitter}/></a>
                    </li>
                  </ul>
                </div>
              </Col>*/}
            </Row>
          </div>
        </div>
      </div>
    </Layout>
  )
}

BlogDetailpage.propTypes = {
  data: PropTypes.shape({
    wpPost: PropTypes.object
  })
}
  
export default BlogDetailpage
  
export const BlogDetailpageQuery = graphql`
  query BlogDetailpage($detailpath: String!) {
    wpPost(link: {eq: $detailpath}) {
      title
          customPostEditor {
            postEditorRelationship {
              __typename
              ... on WpCustomUser {
                title
                customUsers {
                  customUserId
                }
              }
            }
          } 
      metaMain {
        title
        description
        ogimage {
          sourceUrl
        }
      }      
      terms {
        nodes {
          name
          nodeType
          link
          slug
          ... on WpCategory {
            ancestors {
              nodes {
                slug
              }
            }
          }
        }
      }
      date(formatString: "MMM DD, YYYY")
      postFields {
        defaultFields {
          excerpt
          featuredImage {
            sourceUrl
          }
          postTemplates {
            ... on WpPost_Postfields_DefaultFields_PostTemplates_ContentBlock {
              content
            }
            ... on WpPost_Postfields_DefaultFields_PostTemplates_Image {
              image {
                sourceUrl
              }
            }
            ... on WpPost_Postfields_DefaultFields_PostTemplates_InstagramEmbed {
              link
            }
          }
        }
      }
      related_posts {
        nodes {
          categories {
            nodes {
              wpParent {
                node {
                  id
                }
              }
              slug
              name
            }
          }
          slug
          title 
          excerpt
          customPostEditor {
            postEditorRelationship {
              __typename
              ... on WpCustomUser {
                title
                customUsers {
                  customUserId
                }
              }
            }
          } 
          postFields {
            defaultFields {
              featuredImage {
                sourceUrl
              }  
            }
          }
          author {
            node {
              avatar {
                url
              }
              firstName
              lastName
              slug
              moreInformation {
                role
                userLocation
              }
              name
            }
          }
          date(formatString: "DD MMM YYYY")
        }
      }
    }
  }
`
